import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container mar_b" }
const _hoisted_4 = { class: "tjjscnz_wrap" }
const _hoisted_5 = { class: "form_wrap" }
const _hoisted_6 = { class: "form_row" }
const _hoisted_7 = { class: "form_iptbox actived" }
const _hoisted_8 = { class: "t6_row2" }
const _hoisted_9 = {
  key: 0,
  class: "ewm_sub"
}

import Banner from "@/views/online-report/banner/index.vue";
import {ref} from "vue";
import { useRouter } from 'vue-router';
import { ElMessage } from "element-plus";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const projectcode = ref('');
const qrCodeValue = ref('');
const qrCodeSize = ref(200);
const qrcode = ref(false);
 const makeCode = () => {
     qrcode.value = false;
     router.push('/creditPublicity')
 }
 const makeCode0 = () => {
     if(projectcode.value == ''){
         ElMessage.error("请输入项目编号")
     }else{
         qrCodeValue.value = process.env.VUE_APP_FORM_URL + 'qrcodeQuery?projectcode='+projectcode.value;
         qrcode.value = true;
     }
 }
 const makeCode1 = () => {
     if(projectcode.value == ''){
         ElMessage.error("请输入项目编号")
     }else{
         qrcode.value = false;
         router.push({
             path: '/conjunctiveQuery',
             query: {
                 projectcode: projectcode.value
             }
         })
     }
 }
qrcode.value = false;

return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top),
    _createVNode(Banner),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "t6_breadCream" }, [
            _createElementVNode("span", null, "首页"),
            _createTextVNode(),
            _createElementVNode("i", null, ">"),
            _createTextVNode(),
            _createElementVNode("span", null, "建设项目承诺制")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[8] || (_cache[8] = _createElementVNode("h1", null, "建设项目承诺制", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_input, {
                    placeholder: "请输入项目编号",
                    modelValue: projectcode.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((projectcode).value = $event)),
                    class: "ipt_text"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "clear" }, null, -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (makeCode()))
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("span", { class: "icon_box" }, [
                    _createElementVNode("img", { src: "/images/xypj_img.png" })
                  ], -1),
                  _createElementVNode("span", { class: "icon_text" }, "企业信用承诺公示", -1)
                ]))]),
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (makeCode0())),
                  class: "center"
                }, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "icon_box" }, [
                    _createElementVNode("img", { src: "/images/ewm_img.png" })
                  ], -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "icon_text" }, "扫扫二维码", -1)),
                  (qrcode.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_vue_qrcode, {
                          value: qrCodeValue.value,
                          width: qrCodeSize.value
                        }, null, 8, ["value", "width"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("a", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (makeCode1()))
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("span", { class: "icon_box" }, [
                    _createElementVNode("img", { src: "/images/xxcx_img.png" })
                  ], -1),
                  _createElementVNode("span", { class: "icon_text" }, "联合审查信息查询", -1)
                ]))])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})